import { Flex } from "@radix-ui/themes";
import type { Ref } from "react";
import styles from "./hamburger-button.module.css";

export function HamburgerButton({
	isOpen,
	onOpenChange,
	controls,
	buttonRef,
}: {
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
	controls?: string;
	buttonRef?: Ref<HTMLButtonElement>;
}) {
	return (
		<Flex height="85px" width="85px" align="center" justify="center" asChild>
			<button
				type="button"
				ref={buttonRef}
				aria-controls={controls}
				aria-expanded={isOpen}
				aria-label={isOpen ? "Close menu" : "Open menu"}
				data-state={isOpen ? "open" : "closed"}
				onClick={() => onOpenChange(!isOpen)}
				className={styles.hamburgerButton}
			>
				<Flex gap="1" direction="column" width="40%" align="start">
					<span className={styles.hamburgerBar} />
					<span className={styles.hamburgerBar} />
					<span className={styles.hamburgerBar} />
				</Flex>
			</button>
		</Flex>
	);
}
